var DK = DK || {};
DK.GiftSearchFields = {
  init: function () {
    let customerNameField = $("#name");
    let emailField = $("#giftEmail");

    // Disables the email field if either first name or lastname are filled
    // Disables the name fields if email field is filled
    // Search results requires only one or the other
    DK.GiftSearchFields.disableEmailField(customerNameField, emailField);
    DK.GiftSearchFields.disableNameFields(emailField, customerNameField);
  },
  disableEmailField: function (caller, email) {
    caller.on("blur", function () {
      if ($(this).val().length !== 0) {
        DK.GiftSearchFields.disableField(email);
      } else {
        DK.GiftSearchFields.enableField(email);
      }
    });
  },
  disableNameFields: function (caller, customerNameField) {
    caller.on("blur", function () {
      if ($(this).val().length !== 0) {
        DK.GiftSearchFields.disableField(customerNameField);
      } else {
        DK.GiftSearchFields.enableField(customerNameField);
      }
    });
  },
  disableField: function (field) {
    field.prop("disabled", true).val("").addClass("disabled-search-fields");
  },
  enableField: function (field) {
    field.prop("disabled", false).removeClass("disabled-search-fields");
  }
};
$(function () {
  DK.GiftSearchFields.init();
});